import { ThemeOptions } from '@material-ui/core'
import { darkTheme } from './Dark'
import { lightTheme } from './Light'

// Design system ODB Promo: success is teal (the palette has no green),
// warning is yellow and error is pink.
const statusPalette = {
    error: { main: '#E83C78' },
    warning: { main: '#DFA904' },
    info: { main: '#58BFD6' },
    success: { main: '#1F6C7C' },
}

// Controles com 8px de raio (--radius-xs do DS), como nos apps da ODB.
const shape = { borderRadius: 8 }

const typography = {
    fontFamily: 'var(--font-sans)',
    h1: { fontFamily: 'var(--font-display)' },
    h2: { fontFamily: 'var(--font-display)' },
    h3: { fontFamily: 'var(--font-display)' },
    h4: { fontFamily: 'var(--font-display)' },
    h5: { fontFamily: 'var(--font-display)' },
    h6: { fontFamily: 'var(--font-display)' },
}

// Campos com fundo #F3F3F3, como nos apps da ODB (no escuro, neutral-800).
const inputOverrides = (background: string) => ({
    MuiOutlinedInput: {
        root: { backgroundColor: background },
    },
})

export const materialTheme = {
    dark: {
        palette: {
            type: 'dark',
            primary: {
                main: lightTheme.colors.primary,
            },
            secondary: {
                main: lightTheme.colors.secondary,
            },
            background: {
                default: darkTheme.background,
                paper: darkTheme.colors.container.background,
            },
            ...statusPalette,
        },
        typography,
        shape,
        overrides: inputOverrides('#333C45'),
    } as ThemeOptions,
    light: {
        palette: {
            type: 'light',
            primary: {
                main: lightTheme.colors.primary,
                contrastText: '#fff',
            },
            secondary: {
                main: lightTheme.colors.secondary,
            },
            text: {
                primary: '#2E2D2C',
                secondary: '#595959',
            },
            ...statusPalette,
        },
        typography,
        shape,
        overrides: inputOverrides('#F3F3F3'),
    } as ThemeOptions,
}
